<template>
    <div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" class="dropdown-toggle nav-link" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22.222" viewBox="0 0 20 22.222"><g id="Icon" transform="translate(0 1.11)"><rect id="Area" width="20" height="20" transform="translate(0 0.001)" opacity="0"/><g id="Icon-2" data-name="Icon" transform="translate(1.111 0.001)"><path id="_28f940d6-a184-4e42-99aa-0b541e7b6ae6" data-name="28f940d6-a184-4e42-99aa-0b541e7b6ae6" d="M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222" transform="translate(-4.444 -3.333)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/><circle id="f7c0d18f-4f02-4370-a64a-1cc586babf08" cx="4.444" cy="4.444" r="4.444" transform="translate(4.445)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/></g></g></svg>
                <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
            </a>
            <div class="dropdown-menu small m-0 p-0 mw-100">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small"><i class="fa fa-user"></i> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn && !showSimple">
            <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22.222" viewBox="0 0 20 22.222"><g id="Icon" transform="translate(0 1.11)"><rect id="Area" width="20" height="20" transform="translate(0 0.001)" opacity="0"/><g id="Icon-2" data-name="Icon" transform="translate(1.111 0.001)"><path id="_28f940d6-a184-4e42-99aa-0b541e7b6ae6" data-name="28f940d6-a184-4e42-99aa-0b541e7b6ae6" d="M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222" transform="translate(-4.444 -3.333)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/><circle id="f7c0d18f-4f02-4370-a64a-1cc586babf08" cx="4.444" cy="4.444" r="4.444" transform="translate(4.445)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/></g></g></svg>
            </a>
        </div>
        <div v-if="!isLoggedIn && showSimple">
            <a class="nav-link" data-testing="login-select" v-if="showLogin" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="$store.commit('setIsMobileNavigationOpen', false); createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22.222" viewBox="0 0 20 22.222">
                    <g id="Icon" transform="translate(0 1.11)">
                        <rect id="Area" width="20" height="20" transform="translate(0 0.001)" fill="#fcfcfc" opacity="0"/>
                        <g id="Icon-2" data-name="Icon" transform="translate(1.111 0.001)">
                        <path id="_28f940d6-a184-4e42-99aa-0b541e7b6ae6" data-name="28f940d6-a184-4e42-99aa-0b541e7b6ae6" d="M22.222,23.333V21.111a4.444,4.444,0,0,0-4.444-4.444H8.889a4.444,4.444,0,0,0-4.445,4.444v2.222" transform="translate(-4.444 -3.333)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/>
                        <circle id="f7c0d18f-4f02-4370-a64a-1cc586babf08" cx="4.444" cy="4.444" r="4.444" transform="translate(4.445)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.222"/>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        },
        showSimple: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
